var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategories12(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_734_2034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.00024H3.5V3.00024H12V2.00024Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 5.49976H3.5V6.49976H12V5.49976Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9H3.5V10H12V9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 3.5C1.55228 3.5 2 3.05228 2 2.5C2 1.94771 1.55228 1.5 1 1.5C0.447715 1.5 0 1.94771 0 2.5C0 3.05228 0.447715 3.5 1 3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 7.00024C1.55228 7.00024 2 6.55253 2 6.00024C2 5.44796 1.55228 5.00024 1 5.00024C0.447715 5.00024 0 5.44796 0 6.00024C0 6.55253 0.447715 7.00024 1 7.00024Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 10.4998C1.55228 10.4998 2 10.052 2 9.49975C2 8.94747 1.55228 8.49976 1 8.49976C0.447715 8.49976 0 8.94747 0 9.49975C0 10.052 0.447715 10.4998 1 10.4998Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_734_2034"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategories12);
export default __webpack_public_path__ + "static/media/Categories12.66fbc00d57bdce521773fd45656a9d44.svg";
export { ForwardRef as ReactComponent };